/* eslint-disable @typescript-eslint/no-explicit-any */
import 'dayjs/locale/fr';
import React from 'react';
import {FlatList, Platform, Text, View} from 'react-native';
import globalStyle from '../../../styles/globalStyle';
import {styles} from './styles';

type Props = {
  data?: any;
  footer?: any;
};
export function HistoriquePayement({data, footer}: Props) {
  const containerStyle =
    Platform.OS === 'web'
      ? [
          styles.ListContainer,
          globalStyle.containerFluid,
          globalStyle.fullEcranWeb,
        ]
      : styles.ListContainer;

  return (
    <View style={containerStyle}>
      <FlatList
        scrollEnabled={true}
        ListFooterComponent={footer}
        data={data || []}
        keyExtractor={item => `${item.reference}-${item.dateCreation}`}
        renderItem={({item}: {item: any}) => (
          <View style={[styles.ListItemInRow]}>
            <View
              style={[
                Platform.OS === 'web' && {width: 700},
                {flex: 1, flexDirection: 'row', justifyContent: 'center'},
              ]}>
              <View style={{flex: 1, flexDirection: 'column'}}>
                <Text style={styles.titleBlue}>{item.modePaiement} </Text>
                <Text style={styles.ListItemFont}>
                  {'Ref : '}
                  {item.reference}
                </Text>
                <Text style={styles.ListItemFont}>
                  {'Montant : '}
                  {item.montant}
                </Text>
                <Text style={styles.ListItemFont}>
                  {'Motif : '}
                  {item.motif}{' '}
                </Text>
                <Text style={styles.ListItemFont}>
                  {'Statut : '}
                  {item.statut}{' '}
                </Text>
                <View style={styles.ListItemFooter}>
                  <Text style={styles.ListItemFontDate}>
                    {item.dateCreation}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        )}
      />
    </View>
  );
}
